let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f8xD9")).then(() => parcelRequire('b7VxC'));